import { EditRoleContextProvider } from 'lib/context/Role/EditRoleContext/EditRoleContextProvider';
import { NewRoleContextProvider } from 'lib/context/Role/NewRoleContext/NewRoleContextProvider';

import { withErrorBoundary } from 'components/shared/Error/Boundary';

import Allowed from '../Permissions/Allowed';

import Table from './Table';

const Roles = ({ isAdmin = false, forAdmin = false }) => {
  return (
    <Allowed
      requiredPermissions={forAdmin ? 'admin_role.create' : 'role.create'}
      showIllustration
      showMessage>
      <NewRoleContextProvider forAdmin={forAdmin}>
        <EditRoleContextProvider forAdmin={forAdmin}>
          <Table isAdmin={isAdmin} forAdmin={forAdmin} />
        </EditRoleContextProvider>
      </NewRoleContextProvider>
    </Allowed>
  );
};

export default withErrorBoundary(Roles);
